/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * EmployeeProfileAvatarUpdaterRestApi - axios parameter creator
 * @export
 */
export const EmployeeProfileAvatarUpdaterRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Employee Profile Avatar
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployeeProfileAvatar: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('deleteEmployeeProfileAvatar', 'employeeId', employeeId)
            const localVarPath = `/api/v2/employees/{employeeId}/avatar`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Employee Profile Avatar
         * @param {string} employeeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEmployeeProfileAvatar: async (employeeId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('uploadEmployeeProfileAvatar', 'employeeId', employeeId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadEmployeeProfileAvatar', 'file', file)
            const localVarPath = `/api/v2/employees/{employeeId}/avatar`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeProfileAvatarUpdaterRestApi - functional programming interface
 * @export
 */
export const EmployeeProfileAvatarUpdaterRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeProfileAvatarUpdaterRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Employee Profile Avatar
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEmployeeProfileAvatar(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEmployeeProfileAvatar(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeProfileAvatarUpdaterRestApi.deleteEmployeeProfileAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Employee Profile Avatar
         * @param {string} employeeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadEmployeeProfileAvatar(employeeId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadEmployeeProfileAvatar(employeeId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeProfileAvatarUpdaterRestApi.uploadEmployeeProfileAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeProfileAvatarUpdaterRestApi - factory interface
 * @export
 */
export const EmployeeProfileAvatarUpdaterRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeProfileAvatarUpdaterRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Employee Profile Avatar
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEmployeeProfileAvatar(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEmployeeProfileAvatar(employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Employee Profile Avatar
         * @param {string} employeeId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEmployeeProfileAvatar(employeeId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.uploadEmployeeProfileAvatar(employeeId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeProfileAvatarUpdaterRestApi - interface
 * @export
 * @interface EmployeeProfileAvatarUpdaterRestApi
 */
export interface EmployeeProfileAvatarUpdaterRestApiInterface {
    /**
     * 
     * @summary Delete Employee Profile Avatar
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileAvatarUpdaterRestApiInterface
     */
    deleteEmployeeProfileAvatar(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Upload Employee Profile Avatar
     * @param {string} employeeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileAvatarUpdaterRestApiInterface
     */
    uploadEmployeeProfileAvatar(employeeId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * EmployeeProfileAvatarUpdaterRestApi - object-oriented interface
 * @export
 * @class EmployeeProfileAvatarUpdaterRestApi
 * @extends {BaseAPI}
 */
export class EmployeeProfileAvatarUpdaterRestApi extends BaseAPI implements EmployeeProfileAvatarUpdaterRestApiInterface {
    /**
     * 
     * @summary Delete Employee Profile Avatar
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileAvatarUpdaterRestApi
     */
    public deleteEmployeeProfileAvatar(employeeId: string, options?: RawAxiosRequestConfig) {
        return EmployeeProfileAvatarUpdaterRestApiFp(this.configuration).deleteEmployeeProfileAvatar(employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Employee Profile Avatar
     * @param {string} employeeId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileAvatarUpdaterRestApi
     */
    public uploadEmployeeProfileAvatar(employeeId: string, file: File, options?: RawAxiosRequestConfig) {
        return EmployeeProfileAvatarUpdaterRestApiFp(this.configuration).uploadEmployeeProfileAvatar(employeeId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

